import { Injectable, NgModule } from '@angular/core';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import { CarouselModule } from 'primeng/carousel';

import { FeaturedJobsModule } from '@app/shared/featured-jobs/featured-jobs.module';
import { SearchModule } from '@app/shared/search/search.module';
import { CareerOportunitiesModule } from './career-oportunities/career-oportunities.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}

@NgModule({
  declarations: [HomeComponent],
  exports: [],
  imports: [
    CareerOportunitiesModule,
    CarouselModule,
    FeaturedJobsModule,
    HammerModule,
    SearchModule,
    HomeRoutingModule,
  ],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig }],
})
export class HomeModule {}
